module.exports = __webpack_public_path__ + "img/2.40ada741.svg";